<template>
<div id="pageTable" class="customtable2">
    <v-container grid-list-xl fluid paddingZero>
        <v-dialog v-model="statusChangeModal" persistent max-width="290">
            <v-card>
                <v-toolbar color="orange" dark small>
                    <v-toolbar-title></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="cancelUserStatus">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    Are you sure you want to change the status ?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="dark" small @click="cancelUserStatus">
                        No
                    </v-btn>
                    <v-btn color="orange " class="white-text" small @click="updateUserStatus" >
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogCountDetail" max-width="40%" scrollable>
            <v-card>
                <v-toolbar dark color="orange">
                    <v-toolbar-title></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialogCountDetail=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <div>
                        <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                            <div class="flex xs6 text-xs-left">
                                <div class="header text--darken-1 bold">Code Name</div>
                            </div>
                            <div class="flex xs6 text-xs-right">
                                <div class="header text--darken-1 bold">Click Count</div>
                            </div>
                        </div>
                    </div>
                    <div v-for="(value, name) in countDetailArr">
                        <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                            <div class="flex xs5 text-xs-left">
                                <div class="header text--darken-1">{{value.name}}</div>
                            </div>
                            <div class="flex xs1 text-xs-left">
                                <div class="header text--darken-1">:</div>
                            </div>
                            <div class="flex xs6 text-xs-right">
                                <div class="header text--darken-1">{{value.count.length}}</div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogSignUpDetail" max-width="40%" scrollable>
            <v-card>
                <v-toolbar dark color="orange">
                    <v-toolbar-title></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialogSignUpDetail=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <div>
                        <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                            <div class="flex xs6 text-xs-left">
                                <div class="header text--darken-1 bold">Code Name</div>
                            </div>
                            <div class="flex xs6 text-xs-right">
                                <div class="header text--darken-1 bold">SignUp Count</div>
                            </div>
                        </div>
                    </div>
                    <div v-for="(value, name) in signUpDetailArr">
                        <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                            <div class="flex xs5 text-xs-left">
                                <div class="header text--darken-1">{{value.name}}</div>
                            </div>
                            <div class="flex xs1 text-xs-left">
                                <div class="header text--darken-1">:</div>
                            </div>
                            <div class="flex xs6 text-xs-right">
                                <div class="header text--darken-1">{{value.count.length}}</div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogMonthlyPaymentDetail" max-width="40%" scrollable>
            <v-card>
                <v-toolbar dark color="orange">
                    <v-toolbar-title>Payment Report</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialogMonthlyPaymentDetail=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <div>
                        <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                            <div class="flex xs6 text-xs-left">
                                <div class="header text--darken-1 bold">Month</div>
                            </div>
                            <div class="flex xs6 text-xs-right">
                                <div class="header text--darken-1 bold">Earn Count</div>
                            </div>
                        </div>
                    </div>
                    <div v-for="(value, key) in userpaymentDetailMonthWise">
                        <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                            <div class="flex xs5 text-xs-left">
                                <div class="header text--darken-1">{{value.month}}</div>
                            </div>
                            <div class="flex xs1 text-xs-left">
                                <div class="header text--darken-1">:</div>
                            </div>
                            <div class="flex xs6 text-xs-right">
                                <div class="header text--darken-1">{{value.count}}</div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        
        <v-toolbar class="dashboard-toolbar-admin" color="orange" dark>
            <v-toolbar-title>MAXMARKETING</v-toolbar-title>
                <download-excel class="DivFlexInline" v-if="users && users.length > 0"
                    :fetch= "generateData"
                    :export-fields= "downloadExcelHeaders"
                    :name= "`MAXMARKETINGUSERS.xls`"
                >
                    <v-icon class="iconTitle">fa-file-excel</v-icon>  
                </download-excel>
                <div class="DivFlexInline">
                    <v-icon @click="downLoadPdf" class="iconTitle" v-if="users && users.length > 0">fa-file-pdf </v-icon>
                </div>
            <v-spacer></v-spacer>
            <v-flex xs8 text-xs-right>
                <v-btn  @click="getImrUsers()" class="refreshBtn" >
                    <i class="fas fa-sync-alt"></i>
                    REFRESH RESULTS 
                </v-btn>
            </v-flex>
        </v-toolbar>
        <v-layout  wrap>
            <v-flex lg12>
                <div class="padding_search">
                <v-text-field solo append-outer-icon="search" class="customTxt" placeholder="Search" v-model="search"></v-text-field>
                    </div>
            </v-flex>
        </v-layout>
        <v-layout row wrap class="custom-mb">        
                <v-card>
                    <v-card-text class="">
                        <v-spacer></v-spacer>
                            <v-toolbar color="grey darken-1" dark>
                         <v-flex xs12 md3>
           
        </v-flex>
        <v-flex xs12 md6 class="text-xs-center">
              <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
        </v-flex>
        <v-flex xs12 md3 class="text-xs-right">
            <v-layout align-center justify-end row fill-height class="text-xs-right">
                <v-flex xs8 class="text-xs-right"> SHOW</v-flex>
                <v-flex xs4 class="text-xs-right">
                    <v-select class="custom_dropdown" v-model="pagination.rowsPerPage" :items="per_page_arr" data-vv-as="User Status" item-text="name" item-value="value" ></v-select>
                </v-flex>
            </v-layout>
        </v-flex>
           </v-toolbar>
                       
                        <v-spacer></v-spacer>

                        <v-data-table 
                            :disable-initial-sort="true" 
                            :headers="headers"
                            :search="search" 
                            hide-actions
                            :items="users" 
                            :rows-per-page-items="[10,25,50,{text:'All','value':-1}]" 
                            class="elevation-1 tableSquare" 
                            item-key="name" 
                            :pagination.sync="pagination">
                            <v-data-iterator
                                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                                :pagination.sync="pagination"
                            />
                            <template slot="headers" slot-scope="props">
                                <tr>
                                    <th v-for="header in props.headers" 
                                    :key="header.text" 
                                    :style="header.value == 'status' ? 'width:15%' : ''"
                                    :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" 
                                    @click="changeSort(header.value)"
                                    >
                                        <v-icon v-if="header.sort" small>arrow_drop_up</v-icon>
                                        <span style="display: inline-block;" v-html="header.text"></span>
                                    </th>
                                </tr>
                            </template>
                            <template slot="items" slot-scope="props">
                                <td>
                                    <v-tooltip top>
                                        <div slot="activator" class="td-pos-rel">
                                            <template v-if="props.item.restrictedFlag">
                                                <v-icon class="icon-imr-usr-pos-abs" size="15" color="red">fas fa-exclamation-triangle</v-icon>
                                            </template>
                                        </div>
                                        <span>User info contain some restricted words!</span>
                                    </v-tooltip>
                                    {{ props.item.full_name }}
                                    {{ props.item.email }}
                                    {{ props.item.phone }}
                                </td>
                                <td>{{props.item.address}}</td>
                                <td>
                                    <span v-if="props.item.code_count != 0"><a @click="clickCountDetail(props.item)"> {{props.item.code_count}}</a></span>
                                    <span v-else> {{props.item.code_count}}</span>
                                </td>
                                <td>
                                    <span v-if="props.item.sign_ups_count.length != 0"><a @click="SignUpCountDetail(props.item)"> {{props.item.sign_ups_count.length}}</a></span>
                                    <span v-else>{{props.item.sign_ups_count.length}}</span>
                                </td>
                                <td>                                    
                                    <!--{props.item.payment_month}}-->
                                </td>
                                <td><!--{{props.item.payment_year}}--></td>
                                <td>
                                    <!--<span v-if="props.item.all_payment != 0"><a @click="monthlyPaymentDetail(props.item.paymentDetailMonthWise)"> {{props.item.all_payment}}</a></span>
                                    <span v-else>{{props.item.all_payment}}</span>-->
                                </td>
                                <td></td>
                                <td>
                                    <v-select class="custom_dropdown" v-model="props.item.status" :items="(props.item.status == 'active' ? user_status_arr : user_status_arr1)" data-vv-as="User Status" item-text="name" item-value="value" @change="onChangeUserStatus(props)"></v-select>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
           
        </v-layout>
    </v-container>
</div>
</template>

<script>
import {
    mapActions
} from "vuex";
import services from "../../services/HttpService";
import VWidget from "@/components/VWidget";
import moment from "moment";
import config from "../../config";
import utils from "../../util/";
import jsPDF from 'jspdf';
import {
    constants
} from "fs";
export default {
    data() {
        return {
            pagination: {rowsPerPage :10,totalItems :null},
            per_page_arr: [
                {
                    name:'10',
                    value:10
                },
                {
                    name:'20',
                    value:20
                },
                {
                    name:'All',
                    value:1000
                },
            ],
            headers: [                
                {
                    text: "Name <br> Email <br> Phone Number",
                    value: "full_name",
                    sort:false
                },
                // {
                //     text: "Email",
                //     value: "email"
                // },
                // {
                //     text: "Phone Number",
                //     value: "phone"
                // },
                {
                    text: "CITY,<br>STATE",
                    value: "address",
                    sort:true
                },
                {
                    text: "Live<br>Codes",
                    value: "code_count",
                    sort:true
                },
                {
                    text: "Total <br>Sign Ups",
                    value: "sign_ups_count",
                    sort:true
                },
                {
                    text: "PAYMENT<br>MONTH",
                    value: "payment_month",
                    sort:true
                },
                {
                    text: "PAYMENT<br>YEAR",
                    value: "payment_year",
                    sort:true
                },
                {
                    text: "ALL<br>PAYMENT",
                    value: "all_payment",
                    sort:true
                },
                {
                    text: "ONLINE/<br>OFFLINE",
                    value: ""
                },
                {
                    text: "ACTIONS",
                    value: "status",
                    width:10
                },
            ],
            headersForDocs: [
                "NAME",
                "EMAIL",
                "PHONE NUMBER",
                "CITY,STATE",
                "LIVE CODES",
                "TOTAL SIGN UPS",
                "PAYMENT CURRENT MONTH",
                "PAYMENT TO YEAR",
                "ALL PAYMENT",
                "ONLINE/OFFLINE",
                "STATUS"
            ],
            listActions: [
                {
                    title: 'Delete',
                    action:'delete',
                    viewIn:['defaultBussDoc','addMoreBussDoc','otherDoc'],
                    forFiles:['file','folder'],
                },
            ],
            user_status_arr: [
                {
                    name: "Active",
                    value: "active"
                },
                {
                    name: "Cancelled",
                    value: "cancelled"
                }
            ],
            user_status_arr1: [
                {
                    name: "Active",
                    value: "active"
                },
                {
                    name: "Pending",
                    value: "pending"
                },
                {
                    name: "Cancelled",
                    value: "cancelled"
                }
            ],
            users: [],
            search: "",
            countDetailArr: [],
            signUpDetailArr: [],
            currentUserObj: null,
            Issuperadmin:false,
            dialogCountDetail:false,
            dialogSignUpDetail:false,
            dialogMonthlyPaymentDetail:false,
            userpaymentDetailMonthWise:{},
            statusChangeModal:false,
            downloadExcelHeaders:{
                "NAME":"NAME",
                "EMAIL":"EMAIL",
                "PHONE NUMBER":"PHONE NUMBER",
                "CITY,STATE":"CITY,STATE",
                "LIVE CODES":"LIVE CODES",
                "TOTAL SIGN UPS":"TOTAL SIGN UPS",
                "PAYMENT CURRENT MONTH":"PAYMENT CURRENT MONTH",
                "PAYMENT TO YEAR":"PAYMENT TO YEAR",
                "ALL PAYMENT":"ALL PAYMENT",
                "ONLINE/OFFLINE":"ONLINE/OFFLINE",
                "STATUS":"STATUS"
            }
        };
    },
    computed: {
      pages () {
        if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        ) return 0

        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
      }
    },
    mounted() {
        // this.permissionName = this.$store.state.user ? this.$store.state.user.permissions.users : null;
    },
    components: {
        VWidget,
    },
    created() {
        const self = this,
            wApp = window.getApp;
        self.utils = utils;
        self.Issuperadmin = self.$store.state.user.Issuperadmin
        self.getImrUsers();   
    },
    methods: {
        ...mapActions(["login"]),
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        changeSort (column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        },
        downLoadPdf(){
            const self = this;
            let headers = self.createHeaders();
            let doc = new jsPDF(
                {
                    orientation: 'landscape',
                    format: [3200, 3200]
                }
            );
            let pdf = doc.table(1, 1, self.generateData(), headers, { autoSize: true,headerBackgroundColor:'#ff812b' });
            pdf.save('MAXMARKETINGUSERS.pdf');
        },
        createHeaders() {
            let keys = this.headersForDocs;
            let result = [];
            for (let i = 0; i < keys.length; i += 1) {
                result.push({
                    'id' : keys[i],
                    'name': keys[i],
                    'prompt': keys[i],
                });
            }
            return result;
        },
        generateData() {
            const self = this;
            let result = [];
            for (let i = 0; i < self.users.length; i += 1) {
                let usersTmp = self.users[i];
                let userStatus = usersTmp.status?(usersTmp.status.charAt(0).toUpperCase()+usersTmp.status.slice(1)).toString():'';
                let data = {
                    "NAME":(usersTmp.first_name)?usersTmp.first_name.toString():'' + ' '+ (usersTmp.last_name)?usersTmp.last_name.toString():'',
                    "EMAIL":(usersTmp.email)?usersTmp.email.toString():'',
                    "PHONE NUMBER":(usersTmp.phone)?usersTmp.phone.toString():'',
                    "CITY,STATE": "",
                    "LIVE CODES":(usersTmp.code_count)?usersTmp.code_count.toString():'0',
                    "TOTAL SIGN UPS":(usersTmp.code_count)?usersTmp.code_count.toString():'0',
                    "PAYMENT CURRENT MONTH": "",
                    "PAYMENT TO YEAR": "",
                    "ALL PAYMENT": "",
                    "ONLINE/OFFLINE":"",
                    "STATUS":userStatus
                }
                result.push(Object.assign({}, data));
            }
            return result;
        },
        clickCountDetail(props){
            const self = this;
            self.countDetailArr = [];
            props.imrs.map(function(val1){
                let countDetail = {};
                countDetail.name = val1.code_name;
                countDetail.code = val1.code;
                countDetail.count = [];
                val1.imr_analytics.map(function(val2){

                    countDetail.count.push(val2.hit_count)
                    
                })
                self.countDetailArr.push(countDetail);
            });
            self.dialogCountDetail = true;
        },
        SignUpCountDetail(props){
            const self = this;
            self.signUpDetailArr = [];
            props.imrs.map(function(val1){
                let signUpDetail = {};
                signUpDetail.name = val1.code_name;
                signUpDetail.code = val1.code;
                signUpDetail.count = [];
                val1.imr_analytics.map(function(val2){
                    if(val2.sign_up_count != 0){
                        signUpDetail.count.push(val2.sign_up_count)
                    }
                })
                self.signUpDetailArr.push(signUpDetail);
            });
            self.dialogSignUpDetail = true;
        },
        monthlyPaymentDetail(props){
            const self = this;
            self.userpaymentDetailMonthWise = Object.assign({}, props);
            self.dialogMonthlyPaymentDetail = true;
        },
        getImrUsers(){
            const self = this,
            wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });

            let restrictedWord = "anal|anus|arse|ass|fuck|ass hole|assfucker|asshole|assshole|bastard|bitch|black cock|"
            restrictedWord += "bloodyhell|boong|cock|cockfucker|cocksuck|cocksucker|coonnass|crap|cunt|cyberfuck|damn|dar\|"
            restrictedWord += "dick|dirty|douche|dummy|erect|erection|erotic|escort|fag|faggot|fuck|Fuck off|fuck you|"
            restrictedWord += "fuckass|fuckhole|god damn|hard core|hardcore|h omoerotic|hore|lesbian|lesbians|"
            restrictedWord += "mother fucker|motherfuck|motherfucker|orgasm|penis|penis fucker|piss|piss off|porn|"
            restrictedWord += "porno|pornography|pussy|retard|sadist|sex|sexy|shit|slut|son of a bitch|suck|tits|"
            restrictedWord += "viagra|whore|xxx|mic|wop|jap|chink|nip. squint kike|chink|cracker|gook|honkey|negro|nigger|"
            restrictedWord += "sandnigger|spic|whitey|wetback|wigger tar baby|spear chucker|slope|hooknose|jiggaboo|"
            restrictedWord += "jigga|kraut|cracker|niggers|spics|pakis|chinks|nips|krauts|frogs|wops|wogs|paddies|"
            restrictedWord += "limeys|polaks|kikes|dune coons|gooks";
            let regex = new RegExp("\\b(?:" + restrictedWord + ")\\b", "gi");
            services
            .get("users/imr-users", {
                Authorization: "Bearer " + this.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                let curMonth = moment().format('YY-MM');
                let curYear = moment().format('YY');
                let usersArr = res.data.data.map(u1 => {
                    u1.sign_ups_count = [];
                    u1.all_payment_arr = [];
                    u1.paymentDetailMonthWise = {};
                    let curMonthPayment = [];
                    let curYearPayment = [];

                    u1.restrictedFlag = false;
                    // if(u1.first_name.match(regex) || u1.last_name.match(regex) || u1.discourse_user_name.match(regex)){
                    if(u1.first_name.match(regex) || u1.last_name.match(regex)){
                        u1.restrictedFlag = true;
                    }
                    u1.full_name = u1.first_name + ' ' + u1.last_name;
                    u1.imrs.map(function(u2){
                        u2.imr_analytics.map(function(u3){
                            if(u3.sign_up_count != 0){
                                u1.sign_ups_count.push(u3.sign_up_count);
                            }
                        });
                        // u2.imr_credits.map(function(u4){
                        //     if(typeof u1.paymentDetailMonthWise[moment(u4.created_at).format('YY-MM')] != 'undefined'){
                        //         u1.paymentDetailMonthWise[moment(u4.created_at).format('YY-MM')].count += u4.credits;
                        //         u1.paymentDetailMonthWise[moment(u4.created_at).format('YY-MM')].month = moment(u4.created_at).format('MMM-YY');
                        //     } else {
                        //         u1.paymentDetailMonthWise[moment(u4.created_at).format('YY-MM')] = {};
                        //         u1.paymentDetailMonthWise[moment(u4.created_at).format('YY-MM')].count = u4.credits;
                        //         u1.paymentDetailMonthWise[moment(u4.created_at).format('YY-MM')].month = moment(u4.created_at).format('MMM-YY');
                        //     }
                            

                        //     u1.all_payment_arr.push(u4.credits);
                        //     if(moment(u4.created_at).format('YY-MM') == curMonth){
                        //         curMonthPayment.push(u4.credits);
                        //     }
                        //     if(moment(u4.created_at).format('YY') == curYear){
                        //         curYearPayment.push(u4.credits);
                        //     }
                        // });
                    });
                    u1.code_count = u1.imrs.length;
                    u1.tmpStatus = u1.status;
                    // u1.all_payment = u1.all_payment_arr.reduce((a, b) => a+b,0);
                    // u1.payment_month = curMonthPayment.reduce((a, b) => a + b, 0);
                    // u1.payment_year = curYearPayment.reduce((a, b) => a + b, 0);
                    return u1;
                });
                
                self.users = usersArr;
                self.pagination.totalItems = usersArr.length;
            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, "red");
            });
        },
        updateUserStatus() {
            const self = this,
                wApp = window.getApp;
            self.statusChangeModal=false;

            let formData = {};
            formData.uuid = self.currentUserObj.item.uuid;
            formData.status = self.currentUserObj.item.status;
            services.put("users/edit", formData, {
                "Authorization": "Bearer " + this.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (res.data.status) {
                    self._showToast(res.data.message);
                    self.getImrUsers();
                } else {
                    self._showToast(res.data.message, "red");
                } 
            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, "red");
            });
        },
        onChangeUserStatus(props){
            const self = this;
            self.statusChangeModal=true;
            self.currentUserObj=props;
        },
        cancelUserStatus(){
            const self = this;
            self.statusChangeModal=false;
            self.users[self.currentUserObj.index].status = self.currentUserObj.item.tmpStatus;
            self.currentUserObj=null;
        }
    }
}
</script>

<style lang="stylus">
.v-btn.remove-border
    border: none !important;
.tableSquare tbody td
    font-weight: 400;
    font-size: 13px;
    border-right: #ccc solid 1px;
    vertical-align: middle;
.tableSquare .v-datatable thead th.column.sortable:hover, .tableSquare .v-datatable thead th.column.sortable.active
    color: #fff !important;
</style>


// WEBPACK FOOTER //
// src/pages/users/ImrUsers.vue